import { createContext, useState, useRef } from "react";
import moment from "moment";
import useAuth from "../hooks/useAuth";
import useGlobalParams from "../hooks/useGlobalParams";

const SPPositionContext = createContext({});

export const SPPositionProvider = ({ children }) => {
  //Load context values
  const { auth } = useAuth();
  const { globalparams } = useGlobalParams();

  const SPpositionInit = {
    posDate: moment().format("yyyy-MM-DD"),
    interest: Number(globalparams?.InterestRate * 100).toFixed(2) + "%",
    buyer: "WeGrow LLC",
    trader: auth.userCode,
    pincoterm: "FOB",
    quantity: "0.00",
    tolerance: Number(globalparams?.Tolerance * 100).toFixed(2) + "%",
    numpallets: "0.00",
    materialcost: "$0.00",
    outpayload: "0.00",
    outdrayage: "$0.00",
    loading: "$0.00",
    outcollectcharges: "$0.00",
    outboundothers: "$0.00",
    generaldutyimp: "0.00%",
    additionaldutyimp: "0.00%",
    harborfeepct: Number(globalparams.HarborFeePct * 100).toFixed(4) + "%",
    merchprocfeepct: Number(globalparams.MerchProcFeePct * 100).toFixed(4) + "%",
    merchprocfee: "$0.00",
    flatfee: "$0.00",
    tsca: "$0.00",
    isf: "$0.00",
    inpayload: "0.00",
    indrayage: "$0.00",
    unloading: "$0.00",
    incollectcharges: "$0.00",
    inboundothers: "$0.00",
    pcomission: "$0.00",
    pfinancecost: "$0.00",
    freightpmt: "$0.00",
    inspectioncost: "$0.00",
    legal: "$" + Number(globalparams.Legal).toFixed(2),
    pallets: "$0.00",
    other: "$0.00",
    interestcost: "$0.00",
    insurancerate: "0.00%",
    insurancefactor: "0.00",
    whfixedcost: "$0.00",
    whvarcost: "$0.00",
    whgraceperiod: "0",
    whaccrualperiod: "0",
    oceanfreight: "$0.00",
    oceanpayload: "0.00",
  };

  const SPpositionDataInit = {
    posDate: moment().format("yyyy-MM-DD"),
    interest: globalparams?.InterestRate,
    buyerID: 10056,
    traderID: auth.userID,
    pincotermID: 4,
    quantity: 0,
    tolerance: globalparams.Tolerance,
    numpallets: 0,
    materialcost: 0,
    outpayload: 0,
    outdrayage: 0,
    loading: 0,
    outcollectcharges: 0,
    outboundothers: 0,
    generaldutyimp: 0,
    additionaldutyimp: 0,
    harborfeepct: globalparams.HarborFeePct,
    merchprocfeepct: globalparams.MerchProcFeePct,
    flatfee: 0,
    tsca: 0,
    isf: 0,
    inpayload: 0,
    indrayage: 0,
    unloading: 0,
    incollectcharges: 0,
    inboundothers: 0,
    pcomission: 0,
    pfinancecost: 0,
    freightpmt: 0,
    inspectioncost: 0,
    legal: globalparams.Legal,
    pallets: 0,
    other: 0,
    interestcost: 0,
    insurancerate: 0,
    insurancefactor: 0,
    whfixedcost: 0,
    whvarcost: 0,
    whgraceperiod: 0,
    whaccrualperiod: 0,
    oceanfreight: 0,
    oceanpayload: 0,
  };
  const SPpaytermInit = [{ row: 0, portion: "100.00%", payType: "CAD", termdays: "10", type: "new" }];
  const SPpaytermDataInit = [{ row: 0, portion: 1, payTypeID: 1, termdays: 10, type: "new" }];
  const SPpayrow = useRef(0);

  const [SPposition, setSPposition] = useState(SPpositionInit);
  const [SPpositionData, setSPpositionData] = useState(SPpositionDataInit);
  const [SPpaymentterm, setSPPaymentterm] = useState(SPpaytermInit);
  const [SPpaymenttermData, setSPPaymenttermData] = useState(SPpaytermDataInit);
  const [positiontoeditSP, setPositiontoeditSP] = useState();
  const [loadedSP, setLoadedSP] = useState(false);

  return (
    <SPPositionContext.Provider
      value={{
        SPpositionInit,
        SPpositionDataInit,
        SPposition,
        SPpositionData,
        setSPposition,
        setSPpositionData,
        positiontoeditSP,
        setPositiontoeditSP,
        SPpaytermInit,
        SPpaytermDataInit,
        SPpaymentterm,
        setSPPaymentterm,
        SPpaymenttermData,
        setSPPaymenttermData,
        SPpayrow,
      }}
    >
      {children}
    </SPPositionContext.Provider>
  );
};

export default SPPositionContext;
